<template>
  <div>
    <window-header></window-header>
    <nav-form :onlyIcons="true"></nav-form>
    <section>
      <article style="height: 73px; width:411px">
        <field name="codigo" widget="input" searchable label="Código" placeholder="Cód." width="67px"
          style="top:9px; left:25px;" :readonly="mode == 'edit'" inputStyle="font-weight:bold;text-align:center;" />
        <field name="descripcion" widget="input" searchable label="Descripción" help="Descripcion"
          placeholder="Descripcion" width="200px" style="top:9px; left:105px;" />
        <field name="precio" widget="float" type="number" searchable label="Precio" placeholder="0.00" width="70px"
          style="top:9px; right:15px;" />
      </article>
    </section>
    <v-collapse-wrapper ref="main-collapse" :active="true">
      <div class="header" v-collapse-toggle>
        <div class="item-title">Listado</div>
        <div class="item-after">{{ count }}</div>
      </div>
      <div class="my-content" v-collapse-content>
        <hot-table ref="hotTableComponent" :settings="htSettings"></hot-table>
      </div>
    </v-collapse-wrapper>
  </div>
</template>
<script>
import WindowMixin from "./../components/WindowMixin.vue";
import rFormMixin from "./../components/rFormMixin.vue";
import rTableMixin from "./../components/rTableMixin.vue";

export default {
  mixins: [WindowMixin, rFormMixin, rTableMixin],
  data: function () {
    return {
      title: "Coste Fabricación",
      dbAdapter: "coste_fabricacion",
      primary: "codigo",
      sequence: { name: "coste_fabricacion" }
    };
  }
};
</script>
